import { render, staticRenderFns } from "./StatDefaultCard.vue?vue&type=template&id=26981768&scoped=true&"
import script from "./StatDefaultCard.vue?vue&type=script&lang=js&"
export * from "./StatDefaultCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26981768",
  null
  
)

export default component.exports